import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import UpgradeCategory from './components/UpgradeCategory';
import FilterSidebar from './components/FilterSidebar';
import CartSidebar from './components/CartSidebar';
import RecommendationHeader from './components/RecommendationHeader';
import PriceAlertModal from './components/PriceAlertModal';

const UpgradeRecommendations = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [expandedCategories, setExpandedCategories] = useState(['drivetrain']);
  const [filters, setFilters] = useState({
    sortBy: 'relevance',
    priceRange: { min: 0, max: 5000 },
    categories: [],
    brands: [],
    difficulty: [],
    inStock: false,
    freeShipping: false,
    localAvailable: false,
    performanceRating: 0
  });
  const [cartItems, setCartItems] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [priceAlertModal, setPriceAlertModal] = useState({ isOpen: false, product: null });
  const [isLoading, setIsLoading] = useState(true);

  // Mock data for upgrade recommendations
  const mockRecommendations = {
    bikeModel: "Trek Domane SL 5 2023",
    analysisDate: "2025-01-05",
    categories: [
      {
        id: 'drivetrain',
        name: 'Drivetrain',
        icon: 'Settings',
        avgRating: 4.6,
        recommendations: [
          {
            id: 'dt-001',
            name: 'Shimano Ultegra R8100 Groupset',
            description: 'Complete 12-speed electronic shifting system with improved ergonomics and wireless connectivity.',
            installDifficulty: 'Hard',
            performanceRating: 4.8,
            vendors: [
              {
                id: 'v1',
                name: 'BikeShop Pro',
                logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop',
                price: 1299,
                shipping: 'Free',
                inStock: true,
                rating: 4.9,
                isAffiliate: true
              },
              {
                id: 'v2',
                name: 'Cycling Warehouse',
                logo: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=100&h=100&fit=crop',
                price: 1349,
                shipping: '$15',
                inStock: true,
                rating: 4.7,
                isAffiliate: true
              },
              {
                id: 'v3',
                name: 'Local Bike Co',
                logo: 'https://images.unsplash.com/photo-1544191696-15693072b5a7?w=100&h=100&fit=crop',
                price: 1399,
                shipping: 'Free',
                inStock: false,
                rating: 4.8,
                isAffiliate: false
              }
            ],
            image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop'
          },
          {
            id: 'dt-002',
            name: 'SRAM Force AXS 12-Speed Chain',
            description: 'High-performance chain designed for electronic shifting with enhanced durability.',
            installDifficulty: 'Medium',
            performanceRating: 4.5,
            vendors: [
              {
                id: 'v1',
                name: 'BikeShop Pro',
                logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop',
                price: 89,
                shipping: 'Free',
                inStock: true,
                rating: 4.8,
                isAffiliate: true
              },
              {
                id: 'v4',
                name: 'Chain Specialists',
                logo: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=100&h=100&fit=crop',
                price: 95,
                shipping: '$8',
                inStock: true,
                rating: 4.6,
                isAffiliate: true
              }
            ],
            image: 'https://images.unsplash.com/photo-1544191696-15693072b5a7?w=300&h=200&fit=crop'
          }
        ]
      },
      {
        id: 'wheels',
        name: 'Wheels & Tires',
        icon: 'Circle',
        avgRating: 4.4,
        recommendations: [
          {
            id: 'wt-001',
            name: 'Mavic Cosmic Pro Carbon SL',
            description: 'Lightweight carbon wheelset with excellent aerodynamics and responsive handling.',
            installDifficulty: 'Medium',
            performanceRating: 4.7,
            vendors: [
              {
                id: 'v2',
                name: 'Cycling Warehouse',
                logo: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=100&h=100&fit=crop',
                price: 899,
                shipping: 'Free',
                inStock: true,
                rating: 4.8,
                isAffiliate: true
              },
              {
                id: 'v5',
                name: 'Wheel Experts',
                logo: 'https://images.unsplash.com/photo-1544191696-15693072b5a7?w=100&h=100&fit=crop',
                price: 949,
                shipping: 'Free',
                inStock: true,
                rating: 4.9,
                isAffiliate: true
              }
            ],
            image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop'
          },
          {
            id: 'wt-002',
            name: 'Continental GP5000 Tires (25mm)',
            description: 'Premium road tires with excellent grip, low rolling resistance, and puncture protection.',
            installDifficulty: 'Easy',
            performanceRating: 4.6,
            vendors: [
              {
                id: 'v1',
                name: 'BikeShop Pro',
                logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop',
                price: 129,
                shipping: 'Free',
                inStock: true,
                rating: 4.7,
                isAffiliate: true
              },
              {
                id: 'v6',
                name: 'Tire Direct',
                logo: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=100&h=100&fit=crop',
                price: 119,
                shipping: '$12',
                inStock: true,
                rating: 4.5,
                isAffiliate: true
              }
            ],
            image: 'https://images.unsplash.com/photo-1544191696-15693072b5a7?w=300&h=200&fit=crop'
          }
        ]
      },
      {
        id: 'brakes',
        name: 'Brakes',
        icon: 'Disc',
        avgRating: 4.5,
        recommendations: [
          {
            id: 'br-001',
            name: 'Shimano Ultegra R8170 Disc Brakes',
            description: 'Hydraulic disc brakes with excellent modulation and stopping power in all conditions.',
            installDifficulty: 'Hard',
            performanceRating: 4.8,
            vendors: [
              {
                id: 'v1',
                name: 'BikeShop Pro',
                logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop',
                price: 449,
                shipping: 'Free',
                inStock: true,
                rating: 4.9,
                isAffiliate: true
              },
              {
                id: 'v7',
                name: 'Brake Masters',
                logo: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=100&h=100&fit=crop',
                price: 469,
                shipping: 'Free',
                inStock: true,
                rating: 4.6,
                isAffiliate: true
              }
            ],
            image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop'
          }
        ]
      },
      {
        id: 'accessories',
        name: 'Accessories',
        icon: 'Package',
        avgRating: 4.3,
        recommendations: [
          {
            id: 'ac-001',
            name: 'Garmin Edge 1040 Solar',
            description: 'Advanced GPS cycling computer with solar charging and comprehensive training metrics.',
            installDifficulty: 'Easy',
            performanceRating: 4.7,
            vendors: [
              {
                id: 'v8',
                name: 'Tech Cycling',
                logo: 'https://images.unsplash.com/photo-1544191696-15693072b5a7?w=100&h=100&fit=crop',
                price: 749,
                shipping: 'Free',
                inStock: true,
                rating: 4.8,
                isAffiliate: true
              },
              {
                id: 'v9',
                name: 'GPS Specialists',
                logo: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=100&h=100&fit=crop',
                price: 799,
                shipping: '$20',
                inStock: true,
                rating: 4.5,
                isAffiliate: true
              }
            ],
            image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop'
          }
        ]
      }
    ]
  };

  useEffect(() => {
    // Check authentication
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/login');
      return;
    }

    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleCategoryToggle = (categoryId) => {
    setExpandedCategories(prev =>
      prev?.includes(categoryId)
        ? prev?.filter(id => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      sortBy: 'relevance',
      priceRange: { min: 0, max: 5000 },
      categories: [],
      brands: [],
      difficulty: [],
      inStock: false,
      freeShipping: false,
      localAvailable: false,
      performanceRating: 0
    };
    setFilters(resetFilters);
  };

  const handleAddToCart = (recommendation, vendor) => {
    const cartItem = {
      id: recommendation?.id,
      vendorId: vendor?.id,
      name: recommendation?.name,
      price: vendor?.price,
      vendorName: vendor?.name,
      image: recommendation?.image,
      quantity: 1
    };

    setCartItems(prev => {
      const existingItem = prev?.find(item => 
        item?.id === cartItem?.id && item?.vendorId === cartItem?.vendorId
      );

      if (existingItem) {
        return prev?.map(item =>
          item?.id === cartItem?.id && item?.vendorId === cartItem?.vendorId
            ? { ...item, quantity: item?.quantity + 1 }
            : item
        );
      }

      return [...prev, cartItem];
    });

    setShowCart(true);
  };

  const handleAddToWishlist = (recommendation) => {
    // Add to wishlist logic
    const wishlistItem = {
      id: recommendation?.id,
      name: recommendation?.name,
      image: recommendation?.image,
      price: recommendation?.vendors?.[0]?.price,
      addedAt: new Date()?.toISOString()
    };

    const existingWishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const updatedWishlist = [...existingWishlist, wishlistItem];
    localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));

    alert('Added to wishlist!');
  };

  const handleViewDetails = (recommendation, action) => {
    switch (action) {
      case 'details':
        // Navigate to product details or open modal
        break;
      case 'local-installer': navigate('/local-shop-finder', { 
          state: { 
            searchQuery: recommendation?.name,
            serviceType: 'installation' 
          }
        });
        break;
      case 'price-alert':
        setPriceAlertModal({ isOpen: true, product: recommendation });
        break;
      default:
        break;
    }
  };

  const handleUpdateCartQuantity = (itemId, vendorId, newQuantity) => {
    if (newQuantity === 0) {
      handleRemoveFromCart(itemId, vendorId);
      return;
    }

    setCartItems(prev =>
      prev?.map(item =>
        item?.id === itemId && item?.vendorId === vendorId
          ? { ...item, quantity: newQuantity }
          : item
      )
    );
  };

  const handleRemoveFromCart = (itemId, vendorId) => {
    setCartItems(prev =>
      prev?.filter(item => !(item?.id === itemId && item?.vendorId === vendorId))
    );
  };

  const handleCheckout = () => {
    // Redirect to checkout or external vendor
    alert('Redirecting to checkout...');
  };

  const handleSetPriceAlert = (alertData) => {
    // Save price alert
    const existingAlerts = JSON.parse(localStorage.getItem('priceAlerts') || '[]');
    const updatedAlerts = [...existingAlerts, alertData];
    localStorage.setItem('priceAlerts', JSON.stringify(updatedAlerts));
    
    alert('Price alert set successfully!');
  };

  const getTotalRecommendations = () => {
    return mockRecommendations?.categories?.reduce((total, category) => 
      total + category?.recommendations?.length, 0
    );
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="pt-20 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-center h-96">
              <div className="text-center">
                <div className="animate-spin w-8 h-8 border-2 border-accent border-t-transparent rounded-full mx-auto mb-4"></div>
                <p className="text-muted-foreground">Loading your upgrade recommendations...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-20 px-6 pb-12">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <RecommendationHeader
            totalRecommendations={getTotalRecommendations()}
            bikeModel={mockRecommendations?.bikeModel}
            analysisDate={mockRecommendations?.analysisDate}
            onViewAnalysis={() => navigate('/bike-analysis-results')}
            onToggleFilters={() => setShowFilters(!showFilters)}
            onToggleCart={() => setShowCart(!showCart)}
            cartItemCount={cartItems?.length}
            sortBy={filters?.sortBy}
            onSortChange={(value) => handleFiltersChange({ ...filters, sortBy: value })}
          />

          {/* Main Content */}
          <div className="flex gap-6">
            {/* Filters Sidebar - Desktop */}
            <div className="hidden lg:block w-80">
              <FilterSidebar
                filters={filters}
                onFiltersChange={handleFiltersChange}
                onResetFilters={handleResetFilters}
              />
            </div>

            {/* Recommendations */}
            <div className="flex-1 space-y-6">
              {mockRecommendations?.categories?.map((category) => (
                <UpgradeCategory
                  key={category?.id}
                  category={category}
                  isExpanded={expandedCategories?.includes(category?.id)}
                  onToggle={() => handleCategoryToggle(category?.id)}
                  onAddToCart={handleAddToCart}
                  onAddToWishlist={handleAddToWishlist}
                  onViewDetails={handleViewDetails}
                />
              ))}
            </div>

            {/* Cart Sidebar - Desktop */}
            <div className="hidden lg:block w-80">
              <CartSidebar
                cartItems={cartItems}
                onUpdateQuantity={handleUpdateCartQuantity}
                onRemoveItem={handleRemoveFromCart}
                onCheckout={handleCheckout}
                onToggleCart={() => setShowCart(!showCart)}
                isOpen={showCart}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Cart FAB */}
      <div className="lg:hidden">
        <CartSidebar
          cartItems={cartItems}
          onUpdateQuantity={handleUpdateCartQuantity}
          onRemoveItem={handleRemoveFromCart}
          onCheckout={handleCheckout}
          onToggleCart={() => setShowCart(!showCart)}
          isOpen={showCart}
          className="fixed right-6 top-1/2 transform -translate-y-1/2 z-40"
        />
      </div>
      {/* Mobile Filter Modal */}
      {showFilters && (
        <div className="lg:hidden fixed inset-0 z-50 bg-background/80 backdrop-blur-sm">
          <div className="fixed inset-y-0 right-0 w-full max-w-sm bg-card border-l border-border shadow-lg">
            <div className="h-full overflow-y-auto p-6">
              <FilterSidebar
                filters={filters}
                onFiltersChange={(newFilters) => {
                  handleFiltersChange(newFilters);
                  setShowFilters(false);
                }}
                onResetFilters={() => {
                  handleResetFilters();
                  setShowFilters(false);
                }}
              />
            </div>
          </div>
        </div>
      )}
      {/* Price Alert Modal */}
      <PriceAlertModal
        isOpen={priceAlertModal?.isOpen}
        product={priceAlertModal?.product}
        onClose={() => setPriceAlertModal({ isOpen: false, product: null })}
        onSetAlert={handleSetPriceAlert}
      />
    </div>
  );
};

export default UpgradeRecommendations;